import { PAYPAL_DROP_EVENT_PAYMENT } from 'root/src/shared/descriptions/endpoints/endpointIds'
import { authenticationTypes, userGroups } from 'root/src/shared/constants/auth'
import { otherEndpointType } from 'root/src/shared/descriptions/endpoints/lenses'
import paypalDropEventPaymentPayloadSchema from 'root/src/shared/descriptions/endpoints/schemas/requestSchemas/paypalDropEventPaymentPayloadSchema'
import { VALIDATE_TOKEN_ACCOUNT } from 'root/src/shared/descriptions/middlewares/middlewareIds'

const payloadSchema = paypalDropEventPaymentPayloadSchema

export default {
	[PAYPAL_DROP_EVENT_PAYMENT]: {
		authentication: authenticationTypes.authenticated,
		authenticationRole: userGroups.brandUser,
		endpointType: otherEndpointType,
		payloadSchema,
		middlewares: [VALIDATE_TOKEN_ACCOUNT],
	},
}
